import { Navigate, useOutlet, useLocation } from "react-router";
import { useAuthContext } from "app/presentation/contexts/auth/context";
import { HOME_PATH, REDIRECT_URL_KEY } from "app/presentation/constants/app.constant";
import { SplashScreen } from "app/presentation/components/template/SplashScreen";

export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, isInitialized, isLoading, user } = useAuthContext();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const redirectParam = params.get(REDIRECT_URL_KEY);

  // Afficher le splash screen pendant l'initialisation
  if (!isInitialized || isLoading) {
    return <SplashScreen />;
  }

  // Ne pas rediriger si on a un paramètre d'erreur (pour éviter les boucles AuthGuard)
  const hasError = params.has('error');

  if (isAuthenticated && !hasError) {
    // Si une redirection spécifique est demandée via l'URL
    if (redirectParam) {
      return <Navigate to={decodeURIComponent(redirectParam)} replace />;
    }

    // Sinon, redirection basée sur le rôle
    // Sinon, redirection basée sur le rôle ET le mode de l'application
    const appMode = import.meta.env.VITE_APP_MODE || import.meta.env.MODE;
    const userRole = (user?.role || user?.type_utilisateur || "").toLowerCase();
    const isDriverProfile = ["chauffeur", "driver"].includes(userRole);
    const isAdminProfile = ["admin", "entreprise", "superadmin", "super_admin", "controleur", "gestionnaire", "accountant", "support"].includes(userRole);

    if (isDriverProfile) {
      if (appMode === "driver") {
        return <Navigate to="/driver/activity" replace />;
      }
      // Si un driver est sur une app admin, on le laisse mais il sera bloqué par AuthGuard (ou on peut rediriger vers un dashboard générique)
      return <Navigate to={HOME_PATH} replace />;
    }

    if (isAdminProfile) {
      if (appMode === "driver") {
        // Un admin sur l'app chauffeur? On le laisse voir l'app chauffeur s'il veut, ou on redirige.
        return <Navigate to={HOME_PATH} replace />;
      }
      return <Navigate to={HOME_PATH} replace />;
    }

    // Par défaut
    return <Navigate to={HOME_PATH} replace />;
  }

  return <>{outlet}</>;
}